import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderMobileComponent } from "./header-mobile.component";
import { AbsoluteRoutingModule } from "src/app/pipes/absolute-routing/absolute-routing.module";
import { RouterModule } from "@angular/router";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [HeaderMobileComponent],
  imports: [
    CommonModule,
    AbsoluteRoutingModule,
    RouterModule,
    MatMenuModule,
    MatIconModule,
  ],
  exports: [HeaderMobileComponent],
})
export class HeaderMobileModule {}
